import { useMemo } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useGetMeteoWindSpeed } from '../../hooks/useGetMeteoWindSpeed';
import { generateSmartTicks, downsample } from '../../helpers/graphsUtils';

const GraficaMeteoVelocidadViento = ( { meteoId , start , end } ) => {

    const { observations, loading } = useGetMeteoWindSpeed({
        meteoId,
        start,
        end
    });

    const formattedObservations = useMemo(() => downsample(observations.map(o => ({ ...o, timestamp: new Date(o.timestamp).getTime() }))), [observations]);

    const xTicks = useMemo(() => formattedObservations.length > 0 ? generateSmartTicks(formattedObservations[0].timestamp, formattedObservations[formattedObservations.length - 1].timestamp) : [], [formattedObservations]);


  return (
     <div>
           <h3>💨 Velocidad del viento</h3>
     
           {/* Gráfica */}
           {loading ? (
             <p>Cargando observaciones...</p>
           ) : formattedObservations?.length > 0 ? (
             <div style={{ backgroundColor: '#ffffff', borderRadius: '28px', padding: '10px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', marginTop: '10px' }}>
             <ResponsiveContainer width="100%" height={350}>
             <LineChart
               data={formattedObservations}
               margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
             >
               <CartesianGrid strokeDasharray="3 3" />
               <XAxis
                dataKey="timestamp"
                scale="time"
                type="number"
                domain={['auto', 'auto']}
                angle={-45}
                textAnchor="end"
                height={60}
                ticks={xTicks}
                tick={{ fontSize: 14 }}
               tickFormatter={(time) => {
                 const date = new Date(time);
                 return date.toLocaleTimeString([], { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
               }}
              />
               <YAxis label={{ value: 'km/h', angle: -90, position: 'insideLeft' }} />
               <Tooltip
                  cursor={false}
                  offset={100}
                  content={({ active, payload, label }) => {
                    if (active && payload && payload.length) {
                      const date = new Date(label).toLocaleString('es-ES', {
                        day: '2-digit',
                        month: '2-digit',
                        year: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        hourCycle: 'h23'
                      });

                      const windSpeed = payload.find(p => p.dataKey === 'windSpeed')?.value ?? null;

                      return (
                        <div style={{
                          backgroundColor: '#ffffff',
                          border: '1px solid #ccc',
                          borderRadius: '8px',
                          padding: '10px',
                          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                          color: '#333',
                          fontSize: 14
                        }}>
                          <p><strong>{date}</strong></p>
                          {windSpeed !== null && (
                            <p>💨 {windSpeed} km/h</p>
                          )}
                        </div>
                      );
                    }
                    return null;
                  }}
                />

               <Legend verticalAlign="top" height={36} align="right" />
               <Line type="monotone" dataKey="windSpeed" name="Velocidad del viento" stroke="#7700ffff" dot={false} />
             </LineChart>
             </ResponsiveContainer>
             </div>
           ) : (
             formattedObservations?.length === 0 && <p>No hay datos disponibles para esta estación meteo</p>
           )}
     
           
         </div>
  );
};

export default GraficaMeteoVelocidadViento;
